<template>
  <div class="pa-0">
    <!-- Header Section -->
    <div class="primary pa-6 d-flex align-center">
      <v-avatar color="white lighten-2" size="40" class="mr-4 shadow-sm" style="background-color: rgba(255,255,255,0.2) !important;">
        <v-icon color="white" size="20">fas fa-file-invoice</v-icon>
      </v-avatar>
      <div>
        <div class="text-h5 font-weight-black white--text lh-1">Detalle del Documento</div>
        <div class="caption white--text opacity-80 uppercase tracking-widest mt-1">Folio #{{invoice.document_id}} — {{invoice.rznSocRecep}}</div>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')" dark large>
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </div>

    <div class="pa-8">
      <v-row>
        <!-- Info Sidebar -->
        <v-col cols="12" md="4" v-if="!inSet">
          <v-card outlined class="modern-card pa-6 bg-lightgrey mb-6">
            <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-4">Información General</div>
            
            <div class="d-flex flex-column gap-3">
              <div class="info-row">
                <span class="caption grey--text font-weight-bold">Fecha Emisión</span>
                <span class="body-2 font-weight-black primary--text">{{invoice.date_emited|moment('DD/MM/YYYY')}}</span>
              </div>
              <div class="info-row">
                <span class="caption grey--text font-weight-bold">RUT Receptor</span>
                <span class="body-2 font-weight-black primary--text">{{invoice.rutRecep}}</span>
              </div>
              <div class="info-row">
                <span class="caption grey--text font-weight-bold">Razón Social</span>
                <span class="caption font-weight-black primary--text lh-1-2 pl-2">{{invoice.rznSocRecep}}</span>
              </div>
            </div>

            <v-divider class="my-6"></v-divider>

            <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-4">Montos y Saldos</div>
            <div class="d-flex flex-column gap-3">
              <div class="info-row">
                <span class="caption grey--text font-weight-bold">Monto Neto</span>
                <span class="body-2 font-weight-black primary--text">{{invoice.get_subtotal| moneda}}</span>
              </div>
              <div class="info-row">
                <span class="caption grey--text font-weight-bold">IVA ({{invoice.iva}}%)</span>
                <span class="body-2 font-weight-black primary--text">{{invoice.get_iva| moneda}}</span>
              </div>
              <div class="info-row total-row pa-2 rounded-lg mt-2">
                <span class="caption primary--text font-weight-black">TOTAL BRUTO</span>
                <span class="text-h6 font-weight-black primary--text">{{invoice.get_total| moneda}}</span>
              </div>
            </div>

            <v-divider class="my-6"></v-divider>

            <div class="d-flex flex-column gap-3">
              <div class="info-row">
                <span class="caption success--text font-weight-black">PAGADO</span>
                <span class="body-1 font-weight-black success--text">{{invoice.get_payed| moneda}}</span>
              </div>
              <div class="info-row pa-2 rounded-lg" :class="(invoice.get_total-invoice.get_payed) > 0 ? 'error lighten-5' : 'success lighten-5'">
                <span class="caption font-weight-black" :class="(invoice.get_total-invoice.get_payed) > 0 ? 'error--text' : 'success--text'">SALDO PENDIENTE</span>
                <span class="body-1 font-weight-black" :class="(invoice.get_total-invoice.get_payed) > 0 ? 'error--text' : 'success--text'">{{invoice.get_total-invoice.get_payed| moneda}}</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Products Table -->
        <v-col cols="12" :md="inSet?12:8">
          <v-card outlined class="modern-card overflow-hidden">
            <div class="px-6 py-4 border-bottom bg-lightgrey">
              <span class="caption font-weight-black uppercase tracking-widest grey--text">Desglose de Productos / Servicios</span>
            </div>
            
            <v-data-table
              :headers="headers"
              :items="invoice.details"
              :items-per-page="-1"
              :loading="loading"
              class="modern-table no-footer"
              hide-default-footer
            >
              <template v-slot:no-data>
                <div class="pa-12 text-center grey--text">
                  <v-icon size="48" color="grey lighten-3" class="mb-4">fas fa-box-open</v-icon>
                  <p class="body-1 font-weight-bold">No hay detalles disponibles</p>
                </div>
              </template>

              <template v-slot:item.sku="{ item }">
                <span class="caption font-weight-black primary--text tracking-tighter">{{item.sku}}</span>
              </template>

              <template v-slot:item.name="{ item }">
                <span class="body-2 font-weight-bold grey--text text--darken-3 lh-1-2 d-block py-2">{{item.name}}</span>
              </template>

              <template v-slot:item.qty="{ item }">
                <v-chip x-small outlined color="grey darken-1" class="font-weight-black">{{item.qty| number('0.00')}}</v-chip>
              </template>

              <template v-slot:item.price="{ item }">
                <span class="body-2 font-weight-medium">{{item.price| moneda}}</span>
              </template>

              <template v-slot:item.total="{ item }">
                <span class="body-2 font-weight-black primary--text">{{item.price*item.qty| moneda}}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceDetail',
  props: ['invoice', 'inSet'],
  data() {
    return {
      loading: false,
      headers: [
        { text: '#', align: 'start', value: 'nro_linea', class: 'table-header', width: '60px', sortable: false },
        { text: 'Código / SKU', align: 'start', value: 'sku', class: 'table-header', width: '140px', sortable: false },
        { text: 'Descripción del Item', align: 'start', value: 'name', class: 'table-header', sortable: false },
        { text: 'Cant.', align: 'end', value: 'qty', class: 'table-header', width: '90px', sortable: false },
        { text: 'P. Unitario', align: 'end', value: 'price', class: 'table-header', width: '130px', sortable: false },
        { text: 'Importe', align: 'end', value: 'total', class: 'table-header', width: '130px', sortable: false },
      ],
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; border: 1px solid rgba(0,0,0,0.05) !important; background-color: white !important; }
.bg-lightgrey { background-color: #f8fbfc; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
.lh-1 { line-height: 1 !important; }
.lh-1-2 { line-height: 1.2 !important; }
.gap-3 { gap: 12px; }
.uppercase { text-transform: uppercase; }
.tracking-widest { letter-spacing: 1.8px; }
.tracking-tighter { letter-spacing: -0.5px; }
.opacity-80 { opacity: 0.8; }

.info-row { display: flex; justify-content: space-between; align-items: flex-start; }
.total-row { background-color: #eef2f5; }

.modern-table >>> thead th { background-color: #f8fbfc !important; height: 48px !important; text-transform: uppercase; font-size: 0.7rem !important; letter-spacing: 1px; font-weight: 900 !important; color: #607d8b !important; }
.modern-table >>> td { height: 64px !important; border-bottom: 1px solid #f0f3f5 !important; }
.modern-table.no-footer >>> .v-data-footer { display: none; }
</style>